import React from 'react';
import { Spin } from 'antd';

const Loading = () => {
  return (
    <div className="flex items-center justify-center">
      <Spin />
    </div>
  );
};

export default Loading;
